import React, { useEffect, useState } from 'react';
import AudioPlayer from '../ui/AudioPlayer';
import { useDeliveryClient } from '../../kentico/deliveryClient';
import { PageRenderer } from './PageRenderer';
import { useErrorBoundary } from 'react-error-boundary';
import Controls from '../ui/Controls';
import { useAppSelector } from '../../redux/hooks';
import { playbackStatusSelector } from '../../redux/slices/ui';
import { useDispatch } from 'react-redux';
import { setPageMetaData } from '../../redux/slices/pageData';
export function PageLoader({ codename, customerKey, module, setLoading }) {
    const [page, setPage] = useState();
    const [customer, setCustomer] = useState();
    const [isLoading, setIsLoading] = useState(true);
    const [client] = useDeliveryClient();
    const { showBoundary } = useErrorBoundary();
    const playbackStatus = useAppSelector(playbackStatusSelector);
    const dispatch = useDispatch();
    useEffect(() => {
        queryForCustomer(client, customerKey).then(setCustomer).catch(showBoundary);
        const pageQuery = codename
            ? queryForPage(client, codename)
            : queryForStartPage(client, module);
        pageQuery
            .then((page) => {
            setPage(page);
            dispatch(setPageMetaData(page.system));
            setIsLoading(false);
            setLoading && setLoading(false);
        })
            .catch(showBoundary);
    }, [client, codename, module, customerKey, showBoundary]);
    if (isLoading)
        return React.createElement("div", null, "loading...");
    if (!page)
        return React.createElement("div", null, "Element not found...");
    const currentCodename = page?.system.codename;
    const customPage = customer && currentCodename
        ? getCustomPageForCodename(customer, currentCodename)
        : undefined;
    return (React.createElement(React.Fragment, null,
        playbackStatus !== "paused" && React.createElement(Controls, { item: page }),
        React.createElement(AudioPlayer, null,
            React.createElement(PageRenderer, { basePage: page, customPage: customPage }))));
}
function queryForPage(client, codename) {
    return client
        .item(codename)
        .depthParameter(kenticoQueryDepth)
        .toPromise()
        .then((result) => {
        return result.data.item;
    });
}
function queryForStartPage(client, module) {
    return client
        .items()
        .equalsFilter('system.collection', module)
        .anyFilter('elements.module', ['start', 'single_page_module'])
        .depthParameter(kenticoQueryDepth)
        .toPromise()
        .then((result) => {
        const startPage = result.data.items[0];
        if (!startPage) {
            throw `No start page found for module "${module}"`;
        }
        if (result.data.items.length > 1) {
            throw `Multiple start pages found for module "${module}"`;
        }
        return startPage;
    });
}
function queryForCustomer(client, customerKey) {
    return client
        .items()
        .type('customer')
        .equalsFilter('elements.customer_key', customerKey)
        .toPromise()
        .then((result) => {
        // Kentico doesn't support uniqueness constraints in element values,
        // so we have to enforce this in code here.
        if (result.data.items.length > 1) {
            throw `Multiple customers found with customer key "${customerKey}"`;
        }
        return result.data.items[0];
    });
}
function getCustomPageForCodename(customer, codename) {
    return customer.elements.custom_pages.linkedItems.find((page) => page.elements.page_customized.value[0] === codename);
}
export const kenticoQueryDepth = 20;
//# sourceMappingURL=PageLoader.js.map